import { render, staticRenderFns } from "./Masini_list.vue?vue&type=template&id=3203d8f9&scoped=true&"
import script from "./Masini_list.vue?vue&type=script&lang=js&"
export * from "./Masini_list.vue?vue&type=script&lang=js&"
import style0 from "./Masini_list.vue?vue&type=style&index=0&id=3203d8f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3203d8f9",
  null
  
)

export default component.exports